import Logger from '@KrashidBuilt/common/utils/logger';

import { post } from './api';
import { SPEEDLABEL_WEB_API_BASE } from '../constants';

const logger = new Logger(__filename);

export const capture = async (data) => {
    logger.extra(data);
    return await post(`${SPEEDLABEL_WEB_API_BASE}/api/private/print`, true, data);
};